import React from 'react';
import styled from 'styled-components';
import ResponsiveImage from './ResponsiveImage';
import useDeviceDetection from '../hooks/useDeviceDetection';

const TestContainer = styled.div`
  padding: 20px;
  max-width: 1200px;
  margin: 0 auto;
`;

const DeviceInfoCard = styled.div`
  background: #333;
  color: white;
  padding: 20px;
  border-radius: 8px;
  margin-bottom: 30px;
`;

const InfoGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 15px;
  margin-top: 15px;
`;

const InfoItem = styled.div`
  background: #555;
  padding: 10px;
  border-radius: 4px;
`;

const TestImageGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 20px;
  margin-top: 30px;
`;

const ImageTestCard = styled.div`
  border: 1px solid #ddd;
  border-radius: 8px;
  overflow: hidden;
  background: #f9f9f9;
`;

const ImageTitle = styled.h3`
  margin: 0;
  padding: 15px;
  background: #333;
  color: white;
  font-size: 1rem;
`;

const ImageContainer = styled.div`
  height: 200px;
  position: relative;
`;

function DeviceTestPage() {
  const deviceInfo = useDeviceDetection();
  const {
    isMobile,
    isTablet,
    isDesktop,
    screenWidth,
    screenHeight,
    pixelRatio,
    isPortrait,
    getOptimalImageSize
  } = deviceInfo;

  const testImage = '/images/Hero.jpg';

  return (
    <TestContainer>
      <h1>Device Detection & Responsive Image Test</h1>

      <DeviceInfoCard>
        <h2>Current Device Information</h2>
        <InfoGrid>
          <InfoItem>
            <strong>Device Type:</strong><br />
            {isMobile ? 'Mobile' : isTablet ? 'Tablet' : 'Desktop'}
          </InfoItem>
          <InfoItem>
            <strong>Screen Size:</strong><br />
            {screenWidth} × {screenHeight}px
          </InfoItem>
          <InfoItem>
            <strong>Pixel Ratio:</strong><br />
            {pixelRatio}x
          </InfoItem>
          <InfoItem>
            <strong>Orientation:</strong><br />
            {isPortrait ? 'Portrait' : 'Landscape'}
          </InfoItem>
          <InfoItem>
            <strong>Optimal Image Size (800px base):</strong><br />
            {getOptimalImageSize(800)}px
          </InfoItem>
          <InfoItem>
            <strong>Optimal Image Size (400px base):</strong><br />
            {getOptimalImageSize(400)}px
          </InfoItem>
        </InfoGrid>
      </DeviceInfoCard>

      <TestImageGrid>
        <ImageTestCard>
          <ImageTitle>Mobile Optimized (200px base)</ImageTitle>
          <ImageContainer>
            <ResponsiveImage
              src={testImage}
              alt="Test image - Mobile"
              baseWidth={200}
              showDeviceInfo={true}
              hoverEffect={!isMobile}
            />
          </ImageContainer>
        </ImageTestCard>

        <ImageTestCard>
          <ImageTitle>Tablet Optimized (400px base)</ImageTitle>
          <ImageContainer>
            <ResponsiveImage
              src={testImage}
              alt="Test image - Tablet"
              baseWidth={400}
              showDeviceInfo={true}
              hoverEffect={!isMobile}
            />
          </ImageContainer>
        </ImageTestCard>

        <ImageTestCard>
          <ImageTitle>Desktop Optimized (800px base)</ImageTitle>
          <ImageContainer>
            <ResponsiveImage
              src={testImage}
              alt="Test image - Desktop"
              baseWidth={800}
              showDeviceInfo={true}
              hoverEffect={!isMobile}
            />
          </ImageContainer>
        </ImageTestCard>
      </TestImageGrid>

      <div style={{ marginTop: '40px', padding: '20px', background: '#f0f0f0', borderRadius: '8px' }}>
        <h3>How to Test:</h3>
        <ol>
          <li>Open Chrome DevTools (F12)</li>
          <li>Click the device toggle icon (📱) or press Ctrl+Shift+M</li>
          <li>Select different devices from the dropdown</li>
          <li>Watch how the device information updates</li>
          <li>Notice how images adapt to different screen sizes</li>
          <li>On mobile devices, hover effects are disabled</li>
        </ol>
      </div>
    </TestContainer>
  );
}

export default DeviceTestPage;